module.exports = __webpack_public_path__ + "img/right-arrow-white.57188410.svg";